import { isCoreTicketField } from "@/helpers/ticketing.helpers"
import { TicketField } from "./TicketField"

import type { TicketFieldsProps } from "./TicketField.types"

export const TicketFields = (props: TicketFieldsProps) => {
  const { fields, initialValues, createServerErrorRule, ...fieldProps } = props

  return fields
    .filter((field) => !isCoreTicketField(field))
    .map((field) => {
      const initialValue = initialValues?.[field.key]

      return (
        <TicketField
          key={field.key}
          field={field}
          initialValue={typeof initialValue === "string" ? initialValue : ""}
          rules={
            createServerErrorRule ? [createServerErrorRule(field.key)] : []
          }
          {...fieldProps}
        />
      )
    })
}
